function global() {
  console.log('MRMR - Global');
}

export default global;
